import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import PressPage from "../components/press/PressPage";
import { ApiResult } from "../lib/CmsApi";
import PageProps from "../lib/models/pageProps";

export default function PressP(
  props: ApiResult<"listPressReleases"> & ApiResult<"loadPress">
) {
  return <PressPage {...props} />;
}

PressP.getInitialProps = async ({
  api
}: InitialPropsContext): PageProps<
  ApiResult<"listPressReleases"> & ApiResult<"loadPress">
> => {
  const [content, pressEntries] = await Promise.all([
    api.loadPress().catch(() => {
      throw new PageNotFoundError();
    }),
    api
      .listPressReleases({
        limit: 4,
        orderBy: "date",
        order: "desc",
        xRichtextFormat: "plaintext"
      })
      .catch(() => ({ total: 0, items: [] }))
  ]);
  const pageProps = { ...content, ...pressEntries };
  let _pageImages;
  try {
    _pageImages = PressPage.getImages(pageProps);
  } catch (error) {
    console.error(error);
  }

  return { ...pageProps, _pageImages };
};
